// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a78ba249","239":"2253cf6e","455":"43aa0e49"}[chunkId] + ".chunk.js";
};